import { gql } from '@apollo/client';

export const GET_TRACKING_DOMAINS_CSV = gql`
  query trackingDomainsCsv($input: TrackingDomainInput) {
    trackingDomainsCsv(input: $input) {
      csv
    }
  }
`;
